import * as React from "react"
import type { SVGProps } from "react"
const SvgMinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8 13h8q.42 0 .71-.29A1 1 0 0 0 17 12a1 1 0 0 0-.29-.71A1 1 0 0 0 16 11H8a1 1 0 0 0-.71.29A1 1 0 0 0 7 12a.97.97 0 0 0 1 1m4 9a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17A10 10 0 0 1 2 12q0-2.07.79-3.9a10 10 0 0 1 2.14-3.17Q6.28 3.56 8.1 2.78A10 10 0 0 1 12 2q2.07 0 3.9.79a10 10 0 0 1 3.18 2.14q1.34 1.35 2.13 3.17A10 10 0 0 1 22 12a10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.18q-1.34 1.34-3.17 2.13A10 10 0 0 1 12 22m0-2q3.35 0 5.68-2.33A7.7 7.7 0 0 0 20 12q0-3.34-2.33-5.67A7.7 7.7 0 0 0 12 4Q8.66 4 6.33 6.33A7.7 7.7 0 0 0 4 12q0 3.35 2.33 5.68A7.7 7.7 0 0 0 12 20" />
  </svg>
)
export default SvgMinusCircle
